import { ToggleSwitch } from "../../../Components/TableHelper";
import { formatDate, ImageLink } from "../../../utils/constant";
import CardActionMenu from "./CardActionMenu";
const ProductCardView = ({
  data,
  loading,
  handleStatusToggle,
  handleEditClick,
  handleDelete,
}) => {
  if (loading) {
    return (
      <div className="text-center py-5">
        <h5>Loading...</h5>
      </div>
    );
  }

  if (!data?.length) {
    return (
      <div className="text-center py-5">
        <h5>No Products Found</h5>
      </div>
    );
  }

  return (
 <div className="row">
  {data.map((product) => (
    <div
      className="col-xl-3 col-lg-3 col-md-6 mb-4 d-flex"
      key={product._id}
    >
      <article className="product-card admin-product-card h-100 w-100 d-flex flex-column">
        {(product?.qualityId?.qualityName ||
          product?.traceabilityId?.traceabilityName) && (
          <div className="card-strip">
            <strong>{product?.qualityId?.qualityName}</strong>
            {product?.traceabilityId?.traceabilityName &&
              ` - ${product?.traceabilityId?.traceabilityName}`}
          </div>
        )}

        <div className="card-img-wrap">
          <div className="card-menu">
            <CardActionMenu
              data={product}
              handleEditClick={handleEditClick}
              handleDelete={handleDelete}
            />
          </div>

          <img
            src={ImageLink(product?.thumbnailImage?.[0])}
            alt={product?.productTitle || "Product"}
          />
        </div>

        <div className="card-body-custom d-flex flex-column flex-grow-1">
          <div className="product-top-info">
            <div className="info-chip">
              <span className="chip-label">Category :</span>
              <span className="chip-value">
                {product?.categoryId?.categoryName || "-"}
              </span>
            </div>

            <div className="info-chip">
              <span className="chip-label">SKU :</span>
              <span className="chip-value">{product.productSKU}</span>
            </div>
          </div>

          <h5 className="card-name">{product.productTitle}</h5>

          {/* Bottom section always at bottom */}
          <div className="mt-auto">
            <div className="card-actions">
              <ToggleSwitch
                data={product}
                name="isActive"
                checked={product.isActive}
                handleStatusToggle={handleStatusToggle}
                module="Product"
              />
            </div>

            <div className="updated-text">
              Updated: {formatDate(product.updatedAt)}
            </div>
          </div>
        </div>
      </article>
    </div>
  ))}
</div>
  );
};

export default ProductCardView;
